/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $DoctorCRMRegisterStatus = {
  type: 'Enum',
} as const;
